module.exports = __webpack_public_path__ + "images/home-dingtalk-work/article-admin-8a15858f7638516f2c6e504b2087af98.png";